import { httpDelete, httpGet, httpPost } from "../../../api/connection";
import {
  M365GetAuthUrlFn,
  M365GetIntegrationFn,
  M365GetUsersFn,
  M365SaveClientCredentialsFn,
  M365SaveOAuth2CredentialsFn,
} from "./M365.types";

const getIntegration: M365GetIntegrationFn = async (query) => {
  return httpGet("/integrations/m365", query);
};

const getAuthUrl: M365GetAuthUrlFn = async () => {
  return httpGet("/integrations/m365/oauth2/url");
};

const remove = async (values: { integration_id: number }) => {
  return httpDelete(`/integrations/m365/${values.integration_id}`);
};

const saveClientCredentials: M365SaveClientCredentialsFn = async (values) => {
  return httpPost("/integrations/m365/client-credentials", values);
};

const saveOAuth2Credentials: M365SaveOAuth2CredentialsFn = async (values) => {
  return httpPost("/integrations/m365/oauth2", values);
};

const getUsers: M365GetUsersFn = async (query) => {
  return httpGet("/integrations/m365/users", query);
};

const M365API = {
  getIntegration,
  getAuthUrl,
  getUsers,
  delete: remove,
  saveClientCredentials,
  saveOAuth2Credentials,
};

export default M365API;
